import { withStyles } from '@material-ui/core/styles';
import { TableRow } from '../TableRow';

export const StyledTableRow = withStyles(() => ({
	root: {
		border: 'none 0'
	}
}))(TableRow);
